import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getInitials } from '../../utils';

// Tailwind's content scanner needs literal class strings — no computed
// arbitrary values — so both variants are spelled out here rather than
// interpolated from `size`/`shape` props.
const SIZE_CLASSES = {
	32: 'tw:w-8 tw:h-8 tw:text-[12.5px]',
	22: 'tw:w-[22px] tw:h-[22px] tw:text-[10px]',
	72: 'tw:w-[72px] tw:h-[72px] tw:text-[26px] tw:tracking-[-0.02em]',
};

const SHAPE_CLASSES = {
	rounded: 'tw:rounded-[8px]',
	circle: 'tw:rounded-full',
};

// `soft` = accent-tinted tile (table rows). `gradient` = the account-header
// avatar: white text over a diagonal accent gradient, per the detail-page spec.
const TONE_CLASSES = {
	soft: 'tw:bg-accent-soft tw:text-accent-ink',
	gradient: 'tw:text-white tw:shadow-sm tw:bg-[linear-gradient(140deg,var(--tw-color-accent),var(--tw-color-accent-hover))]',
};

/**
 * Initials tile used as the leading element of identity-style columns
 * (`.id-tile` in the entity-list spec, and `.acct-avatar` in the detail-page
 * spec). 32px rounded-8px soft tone by default; pass `size={22} shape="circle"`
 * for the person column, or `size={72} tone="gradient"` for the account header.
 */
function IdTile({ name, size = 32, shape = 'rounded', tone = 'soft' }) {
	return (
		<span
			className={classnames(
				'tw:inline-flex tw:items-center tw:justify-center tw:shrink-0 tw:font-semibold',
				SIZE_CLASSES[size],
				SHAPE_CLASSES[shape],
				TONE_CLASSES[tone],
			)}
		>
			{getInitials(name)}
		</span>
	);
}

IdTile.propTypes = {
	name: PropTypes.string,
	size: PropTypes.oneOf([32, 22, 72]),
	shape: PropTypes.oneOf(['rounded', 'circle']),
	tone: PropTypes.oneOf(['soft', 'gradient']),
};

export default IdTile;
